"use client"
import { useRef, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "./Slider.css"
import image1 from "../../assets/imagen1.jpg"
import image2 from "../../assets/imagen2.jpg"
import image3 from "../../assets/imagen3.jpg"

const slides = [
   {
    subtitle: "",
    title: "Portafolio de Servicios: DEFENSA FINANCIERA S.A.S.",
    description: "En DEFENSA FINANCIERA S.A.S., nos especializamos en la recuperación de saldos a favor de personas naturales y jurídicas ante entidades públicas y privadas vigiladas por la Superintendencia Financiera de Colombia. Nuestro objetivo es garantizar el acceso a los derechos que corresponden a nuestros clientes, ya sea en calidad de titulares, beneficiarios o herederos.",
    image: image1,
    link: "/#servicios",
  },
  {
    subtitle: "",
    title: "Asesoría y Gestión Legal:",
    description: "Verificación y determinación de saldos: Investigamos y consultamos ante las entidades correspondientes para establecer la existencia y el valor exacto de los saldos a su favor. o	Gestión profesional de reclamaciones: Ejecutamos todas las actuaciones jurídicas y administrativas necesarias para la consolidación efectiva de sus derechos. o	Recuperación de recursos: Llevamos a cabo las gestiones idóneas para lograr el pago de los saldos existentes. ",
    image: image1,
    link: "/#servicios",
  },
  {
    subtitle: "",
    title: " Representación Judicial y Administrativa:",
    description: "Representación en instancias administrativas y judiciales. o	Redacción y presentación de documentos legales. o	Presentación de demandas, acciones de tutela y derechos de petición. o	Manejo de impugnaciones y otros recursos legales. o	Impulso de procesos judiciales o administrativos para la defensa y reconocimiento de sus derechos. ",
    image: image2,
    link: "/#servicios",
  },
  {
    subtitle: "",
    title: "Asesoramiento Estratégico:",
    description: "o	Gestión con criterio jurídico y profesional para la resolución de conflictos relacionados con el objeto de la reclamación. o	Garantía de la obtención objetiva, real y efectiva de los derechos reclamados, conforme a la legislación aplicable. o	Resolución de consultas relacionadas con el objeto del contrato.  ",
    image: image3,
    link: "/#servicios",
  },
]

const ImageSlider = () => {
  const sliderRef = useRef(null)
  const sliderContainerRef = useRef(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [allowScroll, setAllowScroll] = useState(false)
  const [isSliderInView, setIsSliderInView] = useState(false)

  // Función para verificar si el slider está visible en el viewport
  const checkSliderVisibility = () => {
    if (!sliderContainerRef.current) return false
    
    const rect = sliderContainerRef.current.getBoundingClientRect()
    const windowHeight = window.innerHeight
    
    // El slider está visible si al menos el 50% está en el viewport
    return (
      rect.top < windowHeight * 0.5 && 
      rect.bottom > windowHeight * 0.5
    )
  }

  useEffect(() => {
    const handleScroll = (event) => {
      const sliderVisible = checkSliderVisibility()
      setIsSliderInView(sliderVisible)
      
      // Solo interceptar scroll si el slider está visible
      if (!sliderVisible) {
        return // Permitir scroll normal cuando el slider no está visible
      }
      
      if (!allowScroll) {
        event.preventDefault()
        if (event.deltaY > 0) {
          if (currentSlide < slides.length - 1) {
            sliderRef.current?.slickNext()
          } else {
            setAllowScroll(true)
            // Scroll suave hacia la siguiente sección
            const nextSection = sliderContainerRef.current?.nextElementSibling
            if (nextSection) {
              nextSection.scrollIntoView({ behavior: "smooth" })
            } else {
              window.scrollTo({
                top: window.scrollY + window.innerHeight,
                behavior: "smooth",
              })
            }
          }
        } else {
          if (currentSlide > 0) {
            sliderRef.current?.slickPrev()
          } else {
            // Permitir scroll hacia arriba cuando estamos en el primer slide
            setAllowScroll(true)
            setTimeout(() => setAllowScroll(false), 100)
          }
        }
      } else {
        // Resetear allowScroll cuando el slider sale del viewport
        if (!sliderVisible && window.scrollY < sliderContainerRef.current?.offsetTop) {
          setAllowScroll(false)
        }
      }
    }

    const handleScrollPassive = () => {
      const sliderVisible = checkSliderVisibility()
      setIsSliderInView(sliderVisible)
      
      // Resetear estado cuando el slider no está visible
      if (!sliderVisible) {
        setAllowScroll(false)
        setCurrentSlide(0)
        sliderRef.current?.slickGoTo(0)
      }
    }

    // Event listener para interceptar scroll (solo cuando el slider está visible)
    window.addEventListener("wheel", handleScroll, { passive: false })
    
    // Event listener pasivo para detectar visibilidad
    window.addEventListener("scroll", handleScrollPassive, { passive: true })

    return () => {
      window.removeEventListener("wheel", handleScroll)
      window.removeEventListener("scroll", handleScrollPassive)
    }
  }, [currentSlide, allowScroll])

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    fade: false,
    arrows: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    adaptiveHeight: false,
  }

  return (
    <div 
      ref={sliderContainerRef}
      className={`slider-container ${isSliderInView ? 'in-view' : ''}`}
    >
      <Slider ref={sliderRef} {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="slider-item">
            <div className="image-section">
              <div className="geometric-background">
                <div className="shape-1"></div>
                <div className="shape-2"></div>
                <div className="shape-3"></div>
              </div>
              <div className="image-container1">
                <img src={slide.image || "/placeholder.svg"} alt={slide.title} />
              </div>
            </div>
            <div className="slide-content">
              <h3 className="slide-subtitle">{slide.subtitle}</h3>
              <h2 className="slide-title">{slide.title}</h2>
              <p className="slide-description">{slide.description}</p>
              <Link to={slide.link} className="slide-button">
                LEER MAS
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default ImageSlider